import { ethers } from 'ethers';

export type JPYCTransferProps = {
  relayerEndpoint: string;
  style: {
    width: number;
    height: number;
  };
  id: string;
  record: any;
  data: any;
  attributes: {
    useGasless: boolean;
  };
  isInCustomList: boolean;
  initId: string;
  onPress?: (actions: any[], metadata: any) => void;
};
export enum CHAIN_IDS {
  ETHEREUM = 1, // Ethereum Mainnet
  POLYGON = 137, // Polygon
  AVALANCHE = 43114, // Avalanche C-Chain
  // POLYGON_AMoy = 80002, // Polygon Amoy (Testnet)
  // AVALANCHE_FUJI = 43113, // Avalanche Fuji (Testnet)
}
// // JPYC Token addresses
export const JPYC_ADDRESSES: Record<CHAIN_IDS, string> = {
  // Ethereum Mainnet
  [CHAIN_IDS.ETHEREUM]: '0xE7C3D8C9a439feDe00D2600032D5dB0Be71C3c29' as const,
  // Polygon
  [CHAIN_IDS.POLYGON]: '0xE7C3D8C9a439feDe00D2600032D5dB0Be71C3c29' as const,
  // Avalanche C-Chain
  [CHAIN_IDS.AVALANCHE]: '0xE7C3D8C9a439feDe00D2600032D5dB0Be71C3c29' as const,
} as const;

export type AssetType = 'native' | 'erc20';

type NativeCurrency = { name: string; symbol: string; decimals: number };
export type NetworkMeta = {
  label: string;
  chainIdHex: string;
  chainId: CHAIN_IDS;
  chainName: string;
  nativeCurrency: NativeCurrency;
  rpcUrls: string[];
  blockExplorerUrls: string[];
  iconUrl: string;
};

export const NETWORKS: Record<CHAIN_IDS, NetworkMeta> = {
  [CHAIN_IDS.POLYGON]: {
    label: 'Polygon',
    chainIdHex: '0x89',
    chainId: CHAIN_IDS.POLYGON,
    chainName: 'Polygon',
    nativeCurrency: { name: 'MATIC', symbol: 'MATIC', decimals: 18 },
    rpcUrls: ['https://polygon-rpc.com'],
    blockExplorerUrls: ['https://polygonscan.com'],
    iconUrl:
      'https://click-assets.s3.ap-northeast-1.amazonaws.com/jypc_icons/polygon-icon.png',
  },
  [CHAIN_IDS.ETHEREUM]: {
    label: 'Ethereum',
    chainIdHex: '0x1',
    chainId: CHAIN_IDS.ETHEREUM,
    chainName: 'Ethereum Mainnet',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: ['https://rpc.ankr.com/eth'],
    blockExplorerUrls: ['https://etherscan.io'],
    iconUrl:
      'https://click-assets.s3.ap-northeast-1.amazonaws.com/jypc_icons/ethereum-icon.png',
  },
  [CHAIN_IDS.AVALANCHE]: {
    label: 'Avalanche',
    chainIdHex: '0xa86a',
    chainId: CHAIN_IDS.AVALANCHE,
    chainName: 'Avalanche C-Chain',
    nativeCurrency: { name: 'AVAX', symbol: 'AVAX', decimals: 18 },
    rpcUrls: ['https://api.avax.network/ext/bc/C/rpc'],
    blockExplorerUrls: ['https://snowtrace.io'],
    iconUrl:
      'https://click-assets.s3.ap-northeast-1.amazonaws.com/jypc_icons/avalanche-icon.png',
  },
};

export type GaslessTransferRequest = {
  recipient: string;
  amount: string; // human amount
  tokenAddress: string;
  signer: ethers.Signer | null;
  relayerEndpoint: string; // required when useGasless = true
  deadline?: number | bigint; // in unix timestamp
};
export type NormalTransferRequest = {
  assetType: AssetType;
  recipient: string;
  amount: string; // human amount
  tokenAddress?: string; // required when assetType = 'erc20'
  decimalsOverride?: number; // optional hint to skip on-chain decimals read
  signer: ethers.Signer | null;
};

export type GaslessRelayPayload = {
  chainId: number;
  tokenAddress: string;
  permitSignature: {
    owner: string;
    spender: string;
    value: string;
    deadline: string;
    v: number;
    r: string;
    s: string;
  };
  recipient: string;
};

// EIP-2612 Permit署名用の型定義
export interface PermitSignature {
  owner: string;
  spender: string;
  value: string; // wei string
  deadline: string; // seconds string
  v: number;
  r: string;
  s: string;
}
